/*! QuickSwatch (sc-color-swatches): hide selected value in header, remove swatch hover tooltips */
function resolveOptionName(root, headerEl) {
  const fromData = root.closest("[data-quickswatch-option-name]")?.dataset.quickswatchOptionName?.trim();
  if (fromData) return fromData;

  const headerText = headerEl?.textContent?.trim() || "";
  if (!headerText) return "";

  const swatchTitle = root.querySelector(".sc-color-swatches__swatch[title]")?.getAttribute("title")?.trim();
  if (swatchTitle && headerText.endsWith(` ${swatchTitle}`)) {
    return headerText.slice(0, -(swatchTitle.length + 1));
  }

  return headerText.replace(/\s+\S+$/, "");
}

function fixSwatchSelection(root) {
  root.querySelectorAll(".sc-color-swatches__swatch").forEach((link) => {
    link.style.removeProperty("border-radius");
  });
}

function fixScColorSwatches(root) {
  const header = root.querySelector(".sc-color-swatches__header");
  const optionName = resolveOptionName(root, header);

  if (header && optionName && header.textContent.trim() !== optionName) {
    header.textContent = optionName;
  }

  root.querySelectorAll(".sc-color-swatches__swatch[title]").forEach((link) => {
    link.removeAttribute("title");
  });

  fixSwatchSelection(root);
}

function bindScColorSwatches(root) {
  if (root.dataset.qsUiFixed) return;
  root.dataset.qsUiFixed = "1";

  fixScColorSwatches(root);

  root.addEventListener(
    "mouseenter",
    (event) => {
      const swatch = event.target.closest(".sc-color-swatches__swatch");
      if (swatch?.hasAttribute("title")) swatch.removeAttribute("title");
    },
    true
  );

  new MutationObserver(() => fixScColorSwatches(root)).observe(root, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ["title", "class"],
  });
}

function scanQuickSwatchUi() {
  document.querySelectorAll(".sc-color-swatches").forEach(bindScColorSwatches);
}

function initQuickSwatchUiFix() {
  scanQuickSwatchUi();

  const productRoot = document.querySelector("product-single, .product-single");
  const observeTarget = productRoot || document.body;

  new MutationObserver(() => scanQuickSwatchUi()).observe(observeTarget, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initQuickSwatchUiFix);
} else {
  initQuickSwatchUiFix();
}
